import { getYear as getYearFns } from 'date-fns';

const getYear = date => {
  return getYearFns(new Date(date));
};

export { getYear };



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/dates.js